import type { IconProps } from './types';

export function Pijama({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 40 Q88 36 100 40 Q128 60 156 40 Q168 36 180 40 Q200 56 220 72 Q212 80 204 84 Q196 76 188 68 L188 108 Q188 116 180 116 L76 116 Q68 116 68 108 L68 68 Q60 76 52 84 Q44 80 36 72 Q56 56 76 40 Z" />
      <path d="M76 136 Q128 132 180 136 Q180 146 180 156 Q178 188 176 220 Q166 224 156 220 Q150 194 144 168 Q136 194 128 220 Q120 194 112 168 Q106 194 100 220 Q90 224 80 220 Q78 188 76 156 Q76 146 76 136 Z" />
      <path d="M76 156 Q128 160 180 156" />
    </svg>
  );
}
